import { ROUTES } from '@/router/routeNames'

export default [
  {
    path: 'questions',
    children: [
      {
        name: ROUTES.QUESTIONS,
        path: '',
        component: () => import('./pages/QuestionsIndex.vue'),
        meta: {
          title: 'Audience Questions',
          description:
            'These are questions you can ask of your visitors within a Flow.',
          rightyPrompts: [
            // {
            //   label: 'Create a question',
            //   prompt: 'Help me create a new question to ask my visitors. I want to learn more about them to personalize their experience.'
            // },
            {
              label: 'Analyze responses',
              drawerLabel: 'Analyze my question responses',
              prompt: 'Analyze the responses I\'ve received to my questions. Show me the segment distribution and any insights.'
            }
          ]
        }
      },
      {
        name: ROUTES.QUESTION,
        path: ':segmentGroupId',
        component: () => import('./pages/SegmentGroupShow.vue'),
        meta: {
          title: 'Question',
          rightyPrompts: [
            {
              label: 'Improve question',
              drawerLabel: 'How can I improve this question?',
              prompt: 'Review this question {{segmentGroupId}} and suggest improvements to the wording, answer options, and layout for better completion rates.'
            },
            // {
            //   label: 'Analyze responses',
            //   prompt: 'Analyze the responses to this question {{segmentGroupId}}. Show me the distribution and any patterns in how visitors are answering.'
            // }
          ]
        },
        props: true
      }
    ]
  },
  {
    path: 'segment-groups',
    children: [
      {
        name: ROUTES.SEGMENTGROUPS,
        path: '',
        component: () => import('./pages/SegmentGroupsIndex.vue'),
        meta: {
          title: 'Segment Groups',
          description:
            'These are categories of segments where visitors are segmented entirely automatically. For example: People who arrive on your site via a specific affiliate URL, returning visitors tagged "Customer", those who landed originally on your pricing page, and so on.',
          helpResource: 'segments.default',
          rightyPrompts: [
            {
              label: 'Find segment opportunities',
              drawerLabel: 'Find new auto-segmentation opportunities',
              prompt: 'Analyze my website activity and traffic sources to find auto-segmentation opportunities. Look at my most visited pages, traffic sources, and referrers. For each opportunity you find, suggest a segment group with specific auto-segment signals I can create. Focus on high-traffic patterns that would be valuable for personalization.'
            },
            {
              label: 'Audience breakdown',
              drawerLabel: 'Show me my audience breakdown',
              prompt: 'Show me a breakdown of my audience. Which segments have the most visitors and what are the trends?'
            }
          ]
        }
      },
      {
        name: ROUTES.SEGMENTGROUPTEMPLATES,
        path: 'templates',
        component: () => { },
        meta: {
          title: 'Segment Group Templates',
          description:
            'These are templates for segment groups. You can use these templates to create new segment groups.'
        }
      },
      {
        name: ROUTES.SEGMENTGROUP,
        path: ':segmentGroupId',
        component: () => import('./pages/SegmentGroupShow.vue'),
        meta: {
          rightyPrompts: [
            {
              label: 'Explain',
              drawerLabel: 'Explain what this segment group does',
              prompt: 'Explain what this segment group {{segmentGroupId}} is used for and how visitors are being segmented. What insights can I gain from this?'
            },
            {
              label: 'Segmentation ideas',
              drawerLabel: 'Suggest auto-segmentation signals',
              prompt: 'Suggest additional auto-segment signals for this segment group {{segmentGroupId}}. What URL parameters, referrers, or page visits could automatically segment visitors?'
            },
            // {
            //   label: 'Usage analysis',
            //   prompt: 'How is this dimension {{segmentGroupId}} being used across my campaigns, flows, and personalizations? Show me where it appears.'
            // }
          ]
        },
        props: true
      }
    ]
  }
]
